import state from "../star-jobs/state";

export function setModalAttachment(state, show) {
    state.modalAttachment.show = show
}
export function setMails(state, mails) {
    state.mails = mails;
}
export function setsendingMail(satte, setsendingMail) {
    state.setsendingMail = setsendingMail
}


// WEBPACK FOOTER //
// ./src/modules/modaldocs/mutations.js